import { useHistory } from "@magento/venia-ui/lib/drivers";
import React from "react";
import { env } from "build/env";
import { useUserContext } from "@overrides_venia/peregrine/context/user";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import defaultClasses from "./header.module.scss";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import { useIntl } from "react-intl";
import { Link, resourceUrl } from "@magento/venia-drivers";
import bg_header_menu_2 from "@Src_main/assets/images/header/bg-header-menu-2.jpg";
import bg_header_menu_3 from "@Src_main/assets/images/header/bg-header-menu-3.jpg";
import LinkBetween from "@Components/LinkBetween/LinkBetween";
import Image from "../Image";
import Icon from "@Components/Icon";
export var HeaderDesktop = _ref => {
  var {
    type,
    classes
  } = _ref;
  var history = useHistory();
  var {
    formatMessage
  } = useIntl();
  var isDefault = type.indexOf("default") !== -1;
  var isTakeaway = type.indexOf("takeaway") !== -1;
  var desktopMenuNavigationLinks = [{
    url: "url.key.restaurant.menu",
    label: "header.menu.menu.title"
  }, {
    url: "url.key.restaurants" + (env.WEBSITE_CODE === "MSCUK" ? ".covent" : ""),
    label: "header.menu.ristoranti.title"
  }, {
    url: "url.key.work.with.us",
    label: "header.menu.lavora_con_noi.title"
  }, {
    url: "url.key.events",
    label: "header.menu.eventi.title"
  }];
  var desktopMenuNavigation = /*#__PURE__*/React.createElement("ul", {
    className: "uk-navbar-nav menu-tree menu-default ".concat(classes.primaryMenu)
  }, desktopMenuNavigationLinks.map((item, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, /*#__PURE__*/React.createElement("div", {
    className: "menu-item ".concat(classes.menuItem, " uk-padding-small"),
    onClick: () => {
      var url = formatMessage({
        id: item.url
      });
      history.push(url);
    }
  }, /*#__PURE__*/React.createElement("span", null, formatMessage({
    id: item.label
  }))))));
  var takeawayMenuNavigation = /*#__PURE__*/React.createElement("ul", {
    className: "uk-navbar-nav menu-tree menu-takeaway ".concat(classes.primaryMenu)
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(LinkBetween, {
    href: resourceUrl(formatMessage({
      id: "url.key.restaurant.menu",
      defaultMessage: "/menu-ristorante"
    })),
    toTakeAway: false,
    className: "menu-item ".concat(classes.menuItem, " menu-item-1")
  }, /*#__PURE__*/React.createElement("span", null, formatMessage({
    id: "header.menu.menu_ristorante.title"
  })))));
  return /*#__PURE__*/React.createElement("div", null, isDefault ? desktopMenuNavigation : null, isTakeaway ? takeawayMenuNavigation : null);
};
export var SocialLinks = _ref2 => {
  var {
    classes
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: "social ".concat(classes !== null && classes !== void 0 && classes.socials ? classes === null || classes === void 0 ? void 0 : classes.socials : "", " uk-margin-auto-top")
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.instagram.com/miscusi.family/",
    className: "ig",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "icon-instagram",
    color: "white"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.facebook.com/miscusi.official",
    className: "fb",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "icon-facebook",
    color: "white"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.tiktok.com/@miscusi.family",
    className: "tt",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "icon-Tiktok",
    color: "white"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.linkedin.com/company/miscusi/",
    className: "in",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "icon-linkedin",
    color: "white"
  })));
};
export var SubMenuDefault2 = _ref3 => {
  var {
    classes
  } = _ref3;
  var {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    id: "subMenuDefault2",
    className: "uk-navbar-dropdown ".concat(classes.subMenu),
    "data-uk-drop": "toggle: .menu-item-2; boundary: !nav; boundary-align: true; pos: bottom-justify; offset: 0; animation: uk-animation-slide-top-small; mode: click;"
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sx ".concat(classes.colSx, " uk-flex uk-flex-column")
  }, /*#__PURE__*/React.createElement("ul", {
    className: "sub-menu-list ".concat(classes.subMenuList, " uk-list")
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
    to: resourceUrl(formatMessage({
      id: "url.key.our.challenge"
    })),
    "data-uk-toggle": "target: #subMenuDefault2"
  }, formatMessage({
    id: "header.menu.sfida.title"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
    to: resourceUrl(formatMessage({
      id: "url.key.our.partners"
    })),
    "data-uk-toggle": "target: #subMenuDefault2"
  }, formatMessage({
    id: "header.menu.produttori.title"
  })))), /*#__PURE__*/React.createElement(SocialLinks, {
    classes: classes
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-dx ".concat(classes.colDx)
  }, /*#__PURE__*/React.createElement(Image, {
    alt: "Menu",
    height: "100%",
    src: bg_header_menu_2,
    title: "Menu",
    width: "100%",
    displayPlaceholder: false
  }))));
};
export var SubMenuDefault3 = _ref4 => {
  var {
    classes
  } = _ref4;
  var {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    id: "subMenuDefault3",
    className: "uk-navbar-dropdown ".concat(classes.subMenu),
    "data-uk-drop": "toggle: .menu-item-3; boundary: !nav; boundary-align: true; pos: bottom-justify; offset: 0; animation: uk-animation-slide-top-small; mode: click;"
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sx ".concat(classes.colSx, " uk-flex uk-flex-column")
  }, /*#__PURE__*/React.createElement("ul", {
    className: "sub-menu-list ".concat(classes.subMenuList, " uk-list")
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
    to: formatMessage({
      id: "url.key.our.path"
    }),
    "data-uk-toggle": "target: #subMenuDefault3"
  }, formatMessage({
    id: "header.menu.nostro_percorso.title"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
    to: resourceUrl(formatMessage({
      id: "url.key.blog"
    })),
    "data-uk-toggle": "target: #subMenuDefault3"
  }, formatMessage({
    id: "header.menu.giornale.title"
  })))), /*#__PURE__*/React.createElement(SocialLinks, {
    classes: classes
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-dx ".concat(classes.colDx)
  }, /*#__PURE__*/React.createElement(Image, {
    alt: "Menu",
    height: "100%",
    src: bg_header_menu_3,
    title: "Menu",
    width: "100%",
    displayPlaceholder: false
  }))));
};
export var TopBarHeader = _ref5 => {
  var {
    type,
    extraClasses
  } = _ref5;
  var classes = mergeClasses(defaultClasses, extraClasses);
  var {
    isMobile
  } = useWindowSize();
  var isDefault = type.indexOf("default") !== -1;
  var {
    formatMessage
  } = useIntl();
  var [{
    isSignedIn,
    currentUser
  }] = useUserContext();
  var account = currentUser ? /*#__PURE__*/React.createElement("div", null, formatMessage({
    id: "header.login.welcome"
  }), " ", currentUser.firstname ? currentUser.firstname : currentUser.email, "!") : null;
  var accediRegistrati = /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-middle"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.circle
  }), /*#__PURE__*/React.createElement("a", {
    "data-uk-toggle": "",
    href: "#offcanvas-login-dx"
  }, formatMessage({
    id: "header.login.accedi"
  })));
  var benvenuto = isMobile ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Link, {
    to: resourceUrl(formatMessage({
      id: "url.key.myaccount"
    }))
  }, account)) : /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-middle"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.circle
  }), window.location.pathname.includes(formatMessage({
    id: "url.key.myaccount"
  })) ? account : /*#__PURE__*/React.createElement("div", {
    onClick: () => {
      UIkit.offcanvas("#offcanvas-my-account").show();
    }
  }, account));
  var topBarHeader = /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.topBarContainer)
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-container-xxlarge"
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-middle ".concat(classes.topBar)
  }, /*#__PURE__*/React.createElement("div", {
    className: "side-left ".concat(classes.sideLeft)
  }, !isDefault ? /*#__PURE__*/React.createElement(LinkBetween, {
    toTakeAway: false,
    href: "/"
  }, "miscusi.com") : null, /*#__PURE__*/React.createElement("a", {
    className: "menu-item ".concat(classes.menuItem, " menu-item-2")
  }, /*#__PURE__*/React.createElement("span", null, formatMessage({
    id: "header.menu.mangiare_bene.title"
  }))), /*#__PURE__*/React.createElement("a", {
    href: WEBSITE_CODE === "MSCUK" ? "https://www.miscusi.com" : null,
    className: WEBSITE_CODE !== "MSCUK" && "menu-item ".concat(classes.menuItem, " menu-item-3")
  }, /*#__PURE__*/React.createElement("span", null, formatMessage({
    id: "header.menu.chi.title"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "side-center ".concat(classes.sideCenter)
  }, /*#__PURE__*/React.createElement(LinkBetween, {
    toTakeAway: false,
    href: formatMessage({
      id: "url.key.ti_serve_aiuto"
    })
  }, formatMessage({
    id: "header.menu.ti_serve_aiuto.title"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "side-right uk-flex uk-flex-middle ".concat(classes.sideRight)
  }, /*#__PURE__*/React.createElement(LinkBetween, {
    href: formatMessage({
      id: "url.key.loyalty"
    }),
    toTakeAway: false
  }, formatMessage({
    id: "header.menu.loyalty.title"
  })), isSignedIn ? benvenuto : accediRegistrati))));
  return topBarHeader;
};